export interface IAuthorization {
  claim: string;
  expireDate: string;
  createdDate: string;
}

export interface IApiKey {
  accessToken: string;
  tokenName: string;
  expireDate: string;
  createdDate: string;
}

export interface IDevice {
  activationCode: string;
  approvedDate: string;
  deviceId: string;
  isApproved: boolean;
  refreshToken: string;
  userAgent: string;
}

export interface IUser {
  departmentName: string;
  userId: string;
  username: string;
  isActive: boolean;
  name: string;
  apiKeys: IApiKey[];
  authorization: IAuthorization[];
  devices: IDevice[];
}

export enum AuthorizationType {
  Admin = "admin",
  Api = "api",
  Basic = "basic_user"
}
